import { render, staticRenderFns } from "./TasksScreen.vue?vue&type=template&id=7e8eba2c&scoped=true&"
import script from "./TasksScreen.vue?vue&type=script&lang=ts&"
export * from "./TasksScreen.vue?vue&type=script&lang=ts&"
import style0 from "./TasksScreen.vue?vue&type=style&index=0&id=7e8eba2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8eba2c",
  null
  
)

export default component.exports